import axiosInstance from "@/api/axiosInstance";
import { SharedWithMeKeyResponse } from "./types";

export const getSharedWithMeKey = async (
  context?: "library" | "library-v2" | "podcasts" | "news" | "partner-network",
): Promise<SharedWithMeKeyResponse> => {
  const params = context ? { context } : undefined;
  const response = await axiosInstance.get<SharedWithMeKeyResponse>(
    "/api/search/shared-with-me-key",
    { params },
  );
  return response.data;
};
